import {
  Checkbox,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@material-ui/core";
import { Formik } from "formik";
import React, { useState } from "react";
import CancelSaveBtns from "../../../../../../common/components/buttons/cancelSaveBtns";
import DeleteBtn from "../../../../../../common/components/buttons/deleteBtn";
import { Prompt } from "react-router";
import { HoursDto, hoursInit, hoursValidationSchema } from "../hours.dtos";
import { useEffect } from "react";
import { DaysEnum_class } from "../../../../../../common/enums/days";
import moment from "moment";
import { useHistory } from "react-router-dom";

interface IProps {
  dialogOpen: boolean;
  onSave: (resource: HoursDto) => void;
  onClose: () => void;
  hours: HoursDto;
  openDeleteDialog: () => void;
}

const HoursDialog: React.FC<IProps> = ({
  dialogOpen,
  onSave,
  onClose,
  hours,
  openDeleteDialog,
}) => {
  const history = useHistory();
  const [dto, setDto] = useState<HoursDto>(hoursInit);

  useEffect(() => {
    setDto(JSON.parse(JSON.stringify(hours)));
  }, [hours]);

  return (
    <Formik
      initialValues={dto}
      validateOnChange={false}
      validateOnBlur={false}
      validationSchema={hoursValidationSchema}
      onSubmit={(values, { setSubmitting }) => {
        setTimeout(() => {
          setSubmitting(false);

          history.push("/visitor-information");
        }, 700);
        onSave({ ...values });
      }}
      enableReinitialize={true}
    >
      {(props) => {
        const {
          values,
          errors,
          touched,
          isSubmitting,
          setFieldValue,
          handleBlur,
          handleChange,
          handleSubmit,
        } = props;
        return (
          <>
            <Dialog open={true}>
              <DialogTitle>Day of the Week</DialogTitle>
              <DialogContent>
                <form onSubmit={handleSubmit} noValidate>
                  <FormControl fullWidth required>
                    <InputLabel>Day</InputLabel>
                    <Select
                      name="day"
                      value={values.day}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={Boolean(errors.day)}
                      required
                    >
                      <MenuItem value={0} disabled>
                        Select Day
                      </MenuItem>
                      {Object.keys(DaysEnum_class.enum)
                        .filter((f) => isNaN(+f) === true)
                        .map((o, i) => (
                          <MenuItem key={o.toString() + i} value={o}>
                            {o}
                          </MenuItem>
                        ))}
                    </Select>
                    <FormHelperText>{errors.day}</FormHelperText>
                  </FormControl>
                  <Grid container item spacing={2} alignItems="flex-start">
                    <Grid item xs={4}>
                      <TextField
                        type="time"
                        size="small"
                        margin="none"
                        value={
                          values.open ? moment(values.open).format("HH:mm") : ""
                        }
                        label="Start Time"
                        name="open"
                        onChange={(e) => {
                          if (
                            e.target.value &&
                            e.target.value.split(":").length > 0
                          ) {
                            let open = moment(new Date());

                            let hour = parseInt(
                              e.target.value.split(":")[0] ?? 0
                            );
                            let minute = parseInt(
                              e.target.value.split(":")[1] ?? 0
                            );

                            open.set({ hour, minute });

                            setFieldValue("open", open);
                          } else {
                            setFieldValue("open", undefined);
                          }
                        }}
                        onBlur={(e) => {
                          handleBlur(e);
                        }}
                        error={Boolean(errors.open && touched.open)}
                        helperText={
                          Boolean(errors.open) && touched.open && errors.open
                        }
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <TextField
                        type="time"
                        size="small"
                        margin="none"
                        value={
                          values.close
                            ? moment(values.close).format("HH:mm")
                            : ""
                        }
                        label="End Time"
                        name="close"
                        onChange={(e) => {
                          if (
                            e.target.value &&
                            e.target.value.split(":").length > 0
                          ) {
                            let close = moment(new Date());

                            let hour = parseInt(
                              e.target.value.split(":")[0] ?? 0
                            );
                            let minute = parseInt(
                              e.target.value.split(":")[1] ?? 0
                            );

                            close.set({ hour, minute });

                            setFieldValue("close", close);
                          } else {
                            setFieldValue("close", undefined);
                          }
                        }}
                        error={Boolean(errors.close && touched.close)}
                        helperText={
                          Boolean(errors.close) && touched.close && errors.close
                        }
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </Grid>
                    <Grid container item justify="flex-end" xs={4}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            name="closedAllDay"
                            color="primary"
                            onClick={() => {
                              setFieldValue(
                                "closedAllDay",
                                !values.closedAllDay
                              );
                            }}
                            size="small"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.closedAllDay || true}
                            checked={values.closedAllDay}
                          />
                        }
                        label="Closed"
                        labelPlacement="start"
                      />
                    </Grid>
                  </Grid>

                  <Grid container justify="flex-end">
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="isActive"
                          color="primary"
                          onClick={() =>
                            setFieldValue("isActive", !values.isActive)
                          }
                          size="small"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.isActive || true}
                          checked={values.isActive}
                        />
                      }
                      label="Active"
                      labelPlacement="start"
                    />
                  </Grid>
                  <Grid
                    container
                    justify={values.id ? "space-between" : "flex-end"}
                  >
                    {values.id ? (
                      <DeleteBtn
                        onClick={() => {
                          openDeleteDialog();
                        }}
                      />
                    ) : null}

                    <CancelSaveBtns
                      isSubmitting={isSubmitting}
                      onClose={onClose}
                      saveText="Save"
                      open={dialogOpen}
                    />
                  </Grid>
                </form>
              </DialogContent>
              <Prompt message="You have unsaved edits, are you sure you want to leave?" />
            </Dialog>
          </>
        );
      }}
    </Formik>
  );
};

export default HoursDialog;
